export default "/static/Nunito-VariableFont_wght-b79d9c.ttf";